import PropTypes from 'prop-types'
import { FeaturedGuideCard } from 'components/card'
import Link from 'components/link'
import { feedGuideViewerPath } from 'lib/urls'
import { TYPE } from '../feed-item-layout'

const GuideCard = ({ imageUrl, postUrl, title, type, teaser }) => {
  let guideLabel
  let bgColor

  switch (type) {
    case TYPE.SAMPLE_REGISTRY:
      guideLabel = 'Sample Registry'
      bgColor = 'salmon-gradient'
      break
    case TYPE.SPONSORED_GUIDE:
      guideLabel = 'Sponsored'
      bgColor = 'forest-gradient'
      break
    default:
      guideLabel = 'Guide'
      bgColor = 'sky-gradient'
  }

  return (
    <Link to={feedGuideViewerPath(postUrl)} routerVersion={4}>
      <FeaturedGuideCard
        bgColor={bgColor}
        guideLabel={guideLabel}
        imageUrl={imageUrl}
        teaser={teaser}
        title={title}
      />
    </Link>
  )
}

GuideCard.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  postUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  teaser: PropTypes.string,
}

export default GuideCard
